import { render, staticRenderFns } from "./AssignWorkJournal.vue?vue&type=template&id=b17f875c&scoped=true&"
import script from "./AssignWorkJournal.vue?vue&type=script&lang=js&"
export * from "./AssignWorkJournal.vue?vue&type=script&lang=js&"
import style0 from "./AssignWorkJournal.vue?vue&type=style&index=0&id=b17f875c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17f875c",
  null
  
)

component.options.__file = "AssignWorkJournal.vue"
export default component.exports